import Footer from "./Footer";

const introLogo = "/reportImages/intro-logo.png";

const TableOfContents = () => {
  const handleRowClick = (id) => {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <img src={introLogo} alt="PAR Logo" className="toc-logo" />
      <div style={{ borderBottom: "2px solid #ccc", margin: "0px 40px" }}></div>

      <div className="toc-container">
        <div className="toc-header">
          <h4 className="toc-heading">Table of Contents</h4>
          <table className="toc-table">
            <tbody>
              {[
                {
                  id: "#about-page",
                  main: "1. About Us",
                  page: "2",
                  isMain: true,
                },
                {
                  id: "#synoptic-section",
                  main: "2. Weather Outlook",
                  page: "4",
                  isMain: true,
                },
                {
                  id: "#synoptic-section",
                  sub: "a. Synoptic Situation",
                  page: "4",
                },
                {
                  id: "#river-flows-and-levels",
                  main: "3. Weekly Reservoirs Outlook",
                  page: "5–8",
                  isMain: true,
                },
                {
                  id: "#river-flows-and-levels",
                  sub: "a. River Flows and Levels",
                  page: "5",
                },
                {
                  id: "#barrages-section",
                  sub: "b. Barrages Summary",
                  page: "6",
                },
                {
                  id: "#rims-section",
                  sub: "c. Rims Summary",
                  page: "7",
                },
                {
                  id: "#dams-section",
                  sub: "d. Dams Summary",
                  page: "8",
                },
              ].map((row, idx) => (
                <tr
                  key={idx}
                  onClick={() => handleRowClick(row.id)}
                  style={{ cursor: "pointer" }}
                >
                  {row.main ? (
                    <>
                      <td className="main">
                        <a href={row.id}>{row.main}</a>
                      </td>
                      <td className="page fw-bold">
                        <a href={row.id}>{row.page}</a>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="sub">
                        <a href={row.id}>{row.sub}</a>
                      </td>
                      <td className="page">
                        <a href={row.id}>{row.page}</a>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ marginTop: "700px" }}>
          <Footer
            footerNumber="3"
            footerText={"Weekly Water & Weather Report"}
          />
        </div>
      </div>
    </>
  );
};

export default TableOfContents;
